import NPC from './NPC.js';
import Pokemon from './Pokemon.js';
import NPCStateMachine from './NPCStateMachine.js';

export default class Trainer extends NPC {
    serialize() {
        return {
            ...super.serialize(),
            battleReward: this.battleReward,
        };
    }

    static async deserialize(data) {
        const newType = data.type === 'lad' ? 'youngster' : data.type;
        const trainer = new Trainer({
            name: data.name,
            identifier: data.identifier,
            position: data.position,
            type: newType,
            direction: data.direction,
            preBattleText: data.preBattleText,
            postBattleText: data.postBattleText,
            text: data.text,
            viewRange: data.viewRange,
            isDefeated: data.isDefeated,
            battleReward: data.battleReward,
            _canInteract: data._canInteract,
            useFresh: data.useFresh !== undefined ? data.useFresh : true,
            party: [], // We'll set this after deserializing and resolving references
        });

        // Deserialize Pokemon party
        trainer.party = await Promise.all(data.party.map((pokemonData) => Pokemon.deserialize(pokemonData)));

        // Resolve trainer references for Trainer's Pokemon
        trainer.party.forEach((pokemon) => {
            // For Trainers, they are usually both original and current trainer
            if (pokemon._originalTrainerId === trainer.name || pokemon._currentTrainerId === trainer.name) {
                pokemon.originalTrainer = trainer;
                pokemon.currentTrainer = trainer;
            }

            // Clean up temporary ID properties
            delete pokemon._originalTrainerId;
            delete pokemon._currentTrainerId;
        });

        // Restore runtime state from parent
        trainer.visible = data.visible;
        trainer.shouldShowExclamationMark = data.shouldShowExclamationMark;
        trainer.isInteracting = data.isInteracting;
        trainer.xModifier = data.xModifier || 0;
        trainer.yModifier = data.yModifier || 0;
        trainer.movementSpeed = data.movementSpeed || 1;
        trainer.collisions = data.collisions || {
            up: false,
            right: false,
            down: false,
            left: false,
        };

        // Restore state machine
        if (data.stateMachine) {
            trainer.stateMachine = NPCStateMachine.deserialize(data.stateMachine, trainer);
        }

        return trainer;
    }

    constructor({
        name,
        identifier,
        position,
        type,
        direction,
        party = [],
        preBattleText = '',
        postBattleText = '',
        text = 'Hello!',
        viewRange = 0,
        OSM,
        isDefeated = false,
        battleReward = 1000,
        _canInteract = true,
        movementPattern,
        useFresh = true,
    }) {
        super({
            name,
            identifier,
            position,
            type,
            party,
            preBattleText,
            postBattleText,
            text,
            viewRange,
            OSM,
            isDefeated,
            _canInteract,
            direction,
            movementPattern,
            useFresh,
        });
        this.battleReward = battleReward;
        this.sourcePosition = {
            x: this.position.x,
            y: this.position.y,
            z: this.position.z,
        };
        this.sourceDirection = this.direction;
    }

    canInteract() {
        if (this.isDefeated) {
            return true;
        }
        return this._canInteract;
    }

    healParty() {
        this.party.forEach((pokemon) => pokemon.heal());
    }

    resetToSourcePosition() {
        this.position = {
            x: this.sourcePosition.x,
            y: this.sourcePosition.y,
            z: this.sourcePosition.z,
        };
        this.direction = this.sourceDirection;
    }
}
